import { Card, CardBody, Col } from "reactstrap";
import { H4, P } from "../../../AbstractElements";

const AddTitleCardHoverImage = () => {
  return (
    <Col xxl="3" xl="4" className="box-col-4">
      <Card className="common-hover">
        <CardBody>
          <div className="overlay-card">
            <div className="overlay">
              <div className="overlay-box" />
              <div className="overlay-box overlay-heading">
                <H4 className="text-white text-truncate">Add the title of the card</H4>
                <hr />
              </div>
              <div className="overlay-box overlay-subtitle">
                <P className="overlay-pera">This is an example card for you to use. you are able to include subtitles in your according.</P>
              </div>
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default AddTitleCardHoverImage;
